import { appColors } from '@/src/theme'

export const colorMap = {
  spotSold: appColors.gray['400'],
  spotBought: appColors.violet['600'],
  spotBoughtOpaque: appColors.violet['300'],
  tranches: appColors.foreground,
  ppas: appColors.teal['500'],
  pacs: appColors.fuchsia['500'],
  actualConsumption: appColors.accentPrimary,
  plannedConsumption: appColors.primary,
  planned: appColors.primary,
}

// Stack order matters here - bars are listed bottom-to-top for positive values

export const PORTFOLIO_PROJECTED_POSTIIVE_BAR_KEYS = [
  'partition.tranches.below',
  'partition.tranches.above',
  'partition.ppas.below',
  'partition.ppas.above',
  'partition.pacs.below',
  'partition.pacs.above',
  'partition.planned.below',
  'partition.planned.above',
  'partition.spotBought.below',
  'partition.spotBought.above',
]
